import o from "./CdrModal.vue2.mjs";
import s from "./styles/CdrModal.module.scss.mjs";
import t from "../../../_virtual/_plugin-vue_export-helper.mjs";
const r = {
  $style: s
}, f = /* @__PURE__ */ t(o, [["__cssModules", r]]);
export {
  f as default
};
